import { render, staticRenderFns } from "./ContentQuoteBlock.vue?vue&type=template&id=d446d6be&scoped=true"
import script from "./ContentQuoteBlock.vue?vue&type=script&lang=js"
export * from "./ContentQuoteBlock.vue?vue&type=script&lang=js"
import style0 from "./ContentQuoteBlock.vue?vue&type=style&index=0&id=d446d6be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d446d6be",
  null
  
)

export default component.exports